import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Formik, Form } from "formik";
import { MultiColumnFormFields } from "@components/common/form/FormFields";
import { PeekDialogContent, PeekDialogActions, PeekButton, useTheme, PeekDivider, PeekTypography, PeekStack, } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
import { FilterDatesFormFields, FilterDatesFormInitialValues, FilterDatesFormValidationSchema, } from "./FilterDatesFormConfig";
export const FilterDatesForm = ({ handleNewDateRange }) => {
    const intl = useIntl();
    const theme = useTheme();
    const [isSingleDate, setIsSingleDate] = useState(false);
    const [daysPeriod, setDaysPeriod] = useState(0);
    const { singleDate, startDate, endDate, datePeriod } = FilterDatesFormFields();
    const adjustDatesBasedOnPeriod = (values) => {
        const { datePeriod } = values;
        const currentDate = new Date();
        const tomorrowDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1);
        let startDate, endDate;
        switch (datePeriod) {
            case 1:
                startDate = formatDate(currentDate);
                endDate = formatDate(tomorrowDate);
                break;
            case 7:
                startDate = formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 6));
                endDate = formatDate(tomorrowDate);
                break;
            case 30:
                startDate = formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 29));
                endDate = formatDate(tomorrowDate);
                break;
            default:
                return values;
        }
        return { startDate, endDate };
    };
    function formatDate(date) {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear()).slice(-2);
        return `${month}/${day}/${year}`;
    }
    const onFilterDatesForm = (values) => {
        if (daysPeriod) {
            const dateRanges = adjustDatesBasedOnPeriod(values);
            handleNewDateRange(dateRanges.startDate === dateRanges.endDate ? { scannedAt: dateRanges.startDate } : Object.assign({}, dateRanges));
            return;
        }
        if (isSingleDate) {
            handleNewDateRange({ scannedAt: values.startDate });
            return;
        }
        handleNewDateRange({ startDate: values.startDate, endDate: values.endDate });
    };
    return (React.createElement(Formik, { onSubmit: onFilterDatesForm, initialValues: FilterDatesFormInitialValues, validationSchema: FilterDatesFormValidationSchema({ datePeriod: daysPeriod, isSingleDate: isSingleDate }) }, ({ values }) => {
        useEffect(() => {
            setIsSingleDate(values.singleDate);
            setDaysPeriod(values.datePeriod);
        }, [values]);
        return (React.createElement(Form, null,
            React.createElement(PeekDialogContent, { sx: { p: theme.spacing(2) } },
                React.createElement(MultiColumnFormFields, { fullWidth: true, fields: singleDate }),
                React.createElement(PeekStack, { direction: "row", spacing: 0.5, mt: theme.spacing(-2), alignItems: "baseline" }, isSingleDate ? (React.createElement(MultiColumnFormFields, { fullWidth: true, fields: startDate })) : (React.createElement(React.Fragment, null,
                    React.createElement(MultiColumnFormFields, { fullWidth: true, fields: startDate }),
                    React.createElement(PeekTypography, { alignSelf: "center" }, "-"),
                    React.createElement(MultiColumnFormFields, { fullWidth: true, fields: endDate })))),
                React.createElement(PeekDivider, { light: true, sx: { mt: theme.spacing(1), mb: theme.spacing(2) } }),
                React.createElement(MultiColumnFormFields, { fullWidth: true, fields: datePeriod })),
            React.createElement(PeekDialogActions, { sx: { p: theme.spacing(2), pt: 0 } },
                React.createElement(PeekButton, { size: "large", type: "submit", color: "primary", variant: "contained", fullWidth: true }, intl.formatMessage(messages.filterDatesSubmit)))));
    }));
};
export default FilterDatesForm;
